import { gql } from 'apollo-angular';

const GET_POTENTIAL_CATEGORIES = gql`
  query GetPotentialCategories($rfpId: Long) {
    potentialCategories(rfpId: $rfpId) {
      id
      name
      carvedInProductCount
      categorySelectionState
      coveredByRfpRecipient
      sellerCount
      parentId
      parents {
        id
        name
        type
        level
      }
      hierarchy
      actualSpend
      continuedSpend
      spend {
        actualSpend
        annualizedSpend
        continuedSpend
      }
      potentialSavings {
        savingsVolume
        buyerEfficiencyStarCount
        buyerEfficiency
      }
    }
  }
`;

export default GET_POTENTIAL_CATEGORIES;
